"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSubProcesses = void 0;
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const FlowNodeParser_1 = require("../../FlowNodeParser");
const ProcessLaneSetParser_1 = require("../../ProcessLaneSetParser");
const SequenceFlowParser_1 = require("../../SequenceFlowParser");
function parseSubProcesses(processData, errors, eventDefinitions) {
    const subProcessesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.SubProcess);
    const noSubProcessesFound = !((subProcessesRaw === null || subProcessesRaw === void 0 ? void 0 : subProcessesRaw.length) > 0);
    if (noSubProcessesFound) {
        return [];
    }
    const subProcesses = subProcessesRaw.map((subProcessRaw) => {
        const flowNodeId = subProcessRaw.id;
        try {
            return parseSubProcess(subProcessRaw, errors, eventDefinitions);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return subProcesses;
}
exports.parseSubProcesses = parseSubProcesses;
function parseSubProcess(subProcessRaw, errors, eventDefinitions) {
    const subProcess = (0, ActivityFactory_1.createActivityInstance)(subProcessRaw, index_1.Model.Activities.SubProcess);
    subProcess.laneSet = (0, ProcessLaneSetParser_1.parseProcessLaneSet)(subProcessRaw);
    subProcess.flowNodes = (0, FlowNodeParser_1.parseProcessFlowNodes)(subProcessRaw, errors, eventDefinitions);
    subProcess.sequenceFlows = (0, SequenceFlowParser_1.parseProcessSequenceFlows)(subProcessRaw);
    subProcess.associations = parseAssociations(subProcessRaw);
    subProcess.dataStoreReferences = parseDataStoreReferences(subProcessRaw);
    subProcess.dataObjectReferences = parseDataObjectReferences(subProcessRaw);
    subProcess.dataObjects = parseDataObjects(subProcessRaw);
    return subProcess;
}
function parseAssociations(data) {
    const associationsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.Association);
    const noAssociationsFound = !((associationsRaw === null || associationsRaw === void 0 ? void 0 : associationsRaw.length) > 0);
    if (noAssociationsFound) {
        return [];
    }
    return associationsRaw.map((associationRaw) => {
        const association = (0, TypeFactory_1.createObjectWithCommonProperties)(associationRaw, index_1.Model.ProcessElements.Association);
        association.name = associationRaw.name;
        association.sourceRef = associationRaw.sourceRef;
        association.targetRef = associationRaw.targetRef;
        return association;
    });
}
function parseDataStoreReferences(data) {
    const referencesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.DataStoreReference);
    const noReferencesFound = !((referencesRaw === null || referencesRaw === void 0 ? void 0 : referencesRaw.length) > 0);
    if (noReferencesFound) {
        return [];
    }
    return referencesRaw.map((referenceRaw) => {
        const reference = (0, TypeFactory_1.createObjectWithCommonProperties)(referenceRaw, index_1.Model.ProcessElements.DataStoreReference);
        reference.name = referenceRaw.name;
        return reference;
    });
}
function parseDataObjectReferences(data) {
    const referencesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.DataObjectReference);
    const noReferencesFound = !((referencesRaw === null || referencesRaw === void 0 ? void 0 : referencesRaw.length) > 0);
    if (noReferencesFound) {
        return [];
    }
    return referencesRaw.map((referenceRaw) => {
        const reference = (0, TypeFactory_1.createObjectWithCommonProperties)(referenceRaw, index_1.Model.ProcessElements.DataObjectReference);
        reference.name = referenceRaw.name;
        reference.dataObjectRef = referenceRaw.dataObjectRef;
        return reference;
    });
}
function parseDataObjects(data) {
    const dataObjectsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.DataObject);
    const noDataObjectsFound = !((dataObjectsRaw === null || dataObjectsRaw === void 0 ? void 0 : dataObjectsRaw.length) > 0);
    if (noDataObjectsFound) {
        return [];
    }
    return dataObjectsRaw.map((dataObjectRaw) => {
        return (0, TypeFactory_1.createObjectWithCommonProperties)(dataObjectRaw, index_1.Model.ProcessElements.DataObject);
    });
}
//# sourceMappingURL=SubprocessParser.js.map